import React from 'react';
import { Typography } from '@mui/material';
import { SimpleTable } from './components/SimpleTable';
import { FiltersBar } from './CrmFiltersBar';

export type AbandonedCartDto = {
  email: string;
  productId: number;
  productType: string;
  userId: number | null;
  lastActivityAt: string;
};

function createColumns() {
  return [
    {
      title: 'Email',
      render: (row: AbandonedCartDto) => (
        <span className="select-all">{row.email}</span>
      ),
    },
    {
      title: 'Product type',
      render: (row: AbandonedCartDto) => <div>{row.productType}</div>,
    },
    {
      title: 'Product ID',
      render: (row: AbandonedCartDto) => <div>{row.productId}</div>,
    },
    {
      title: 'User ID',
      render: (row: AbandonedCartDto) => <div>{row.userId ?? '-'}</div>,
    },
    {
      title: 'Last activity',
      render: (row: AbandonedCartDto) => (
        <div>{new Date(row.lastActivityAt).toLocaleDateString()}</div>
      ),
    },
  ].map((c) => ({ ...c, sorting: false }));
}

export type AbandonedCartsTableProps = {
  data: AbandonedCartDto[];
  totalResults: number;
  isFetching?: boolean;
};
export function AbandonedCartsTable({
  data,
  totalResults,
  isFetching,
  ...props
}: AbandonedCartsTableProps) {
  const columns = createColumns();

  return (
    <div className="max-w-full">
      <FiltersBar totalResults={totalResults} isFetching={isFetching}>
        <></>
      </FiltersBar>
      <div className="my-3 text-sm text-[#8A8E99]">
        <Typography>
          Preview: everyone who typed their email at checkout (grouped by
          product). This is not yet the final abandoned-cart list — it has no
          1-hour rule and no conversion status, so it can include people who
          went on to buy.
        </Typography>
      </div>
      <SimpleTable {...props} columns={columns} data={data} />
    </div>
  );
}
